export default "__VITE_ASSET__CVXdwODg__"